import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/video-play-icon.png';
const _withScopeId = n => (_pushScopeId("data-v-ae977c4c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "upload-media-item"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "video-mask"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  key: 2,
  class: "uploading-view center-full"
};
const _hoisted_7 = {
  key: 2,
  class: "error-view"
};
const _hoisted_8 = {
  key: 3,
  class: "option-view"
};
const _hoisted_9 = ["src"];
import { uploader } from "@/utils/alioss";
import PlvVideoUpload from '@polyv/vod-upload-js-sdk';
import { watch, ref, computed, reactive, onUnmounted } from 'vue';
import { ImagePreview, Toast } from 'vant';
import { fetchPolyvSignApi } from '@/api/test';
export default /*#__PURE__*/_defineComponent({
  __name: 'upload-media-item',
  props: {
    file: {
      type: Object,
      default: () => ({})
    },
    // 强制指定文件类型
    justMediaType: {
      type: Number,
      default: 0
    }
  },
  emits: ['delete', 'success', 'fail', 'statusChange'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const state = reactive({
      showVideo: false,
      percentage: 0,
      uploadStatus: 0
    });
    const percentageText = computed(() => state.percentage.toFixed(0) + '%');
    const rate = ref(0);
    let _videoUploader = null;
    const mediaType = computed(() => {
      const ext = getFileExtension(props.file.file.name);
      if (ext == 'jpg' || ext == 'jpeg' || ext == 'png') return 1;
      if (ext == 'mp4' || ext == 'mov') return 2;
      return 0;
    });
    onUnmounted(() => {
      if (_videoUploader) _videoUploader.clearAll();
    });
    // 刷新签名
    const updateSign = async () => {
      var _res$data;
      const res = await fetchPolyvSignApi();
      const data = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
      _videoUploader.updateUserData({
        userid: data.userid,
        ptime: data.ptime,
        sign: data.sign,
        hash: data.hash
      });
    };
    // 开始图片上传
    const startImageUpload = async () => {
      console.log('开始上传', props.file);
      // 上传至oss
      try {
        state.uploadStatus = 1;
        const res = await uploader(props.file.file);
        state.uploadStatus = 2;
        props.file.url = res.url;
        emits('success');
        console.log('上传成功', props.file.url);
      } catch (e) {
        state.uploadStatus = 3;
        emits('fail');
        Toast.fail('上传失败');
        console.error('上传失败', e);
      }
    };
    // 开始视频上传
    let _uploadTasker = null;
    const startVideoUpload = async () => {
      if (!_videoUploader) {
        _videoUploader = new PlvVideoUpload({
          events: {
            // 错误事件回调
            Error: err => {
              state.uploadStatus = 3;
              Toast.fail(err.message);
            }
          }
        });
      }
      // 签名3分钟有效期
      try {
        await updateSign();
      } catch (e) {
        Toast.fail(e.msg || '签名错误');
        state.uploadStatus = 3;
        return;
      }
      // 开始创建任务
      if (_uploadTasker) _videoUploader.removeFile(_uploadTasker.id);
      const fileSetting = {
        title: props.file.name || '服务进程内容',
        desc: '',
        cataid: '',
        tag: '服务进程',
        luping: 1,
        keepsource: 0 // 是否源文件播放（不对视频进行编码）：0为编码，1为不编码
      };

      _uploadTasker = _videoUploader.addFile(props.file.file,
      // file 为待上传的文件对象
      {
        // 文件开始上传回调
        FileStarted: info => {
          state.uploadStatus = 1;
          console.log('开始上传', info);
        },
        // 文件上传过程返回上传进度信息回调
        FileProgress: info => {
          state.percentage = parseInt((info.progress * 100).toFixed(0));
          console.log('上传进度', state.percentage);
        },
        // 文件上传成功回调
        FileSucceed: info => {
          var _info$fileData;
          state.uploadStatus = 2;
          props.file.url = (_info$fileData = info.fileData) === null || _info$fileData === void 0 ? void 0 : _info$fileData.vid;
          console.log('上传成功', info);
        },
        // 文件上传失败回调
        FileFailed: info => {
          state.uploadStatus = 3;
          console.log('上传失败', info);
        }
      }, fileSetting);
      _videoUploader.resumeFile(_uploadTasker.id);
    };
    // 删除
    const deleteClick = () => {
      emits('delete');
    };
    // 获取后缀类型
    const getFileExtension = filePath => {
      if (!filePath) return '';
      return filePath.slice((filePath.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();
    };
    // 大图预览
    const showBigClick = () => {
      ImagePreview([props.file.objectUrl]);
    };
    // 播放视频
    const playVideoClick = () => {
      state.showVideo = true;
    };
    const startUpload = async () => {
      // 正在上传中，不能重复点击
      if (state.uploadStatus == 1) return;
      if (mediaType.value == 1 && (props.justMediaType == 0 || props.justMediaType == 1)) {
        startImageUpload();
        props.file.mediaType = 1;
      } else if (mediaType.value == 2 && (props.justMediaType == 0 || props.justMediaType == 2)) {
        startVideoUpload();
        props.file.mediaType = 2;
      } else {
        if (props.justMediaType == 1) Toast('文件格式错误，只支持JPG、JPEG、PNG 格式');else if (props.justMediaType == 2) Toast('文件格式错误，只支持MP4、MOV 格式');else Toast('文件格式错误，只支持JPG、JPEG、PNG、MP4、MOV 格式');
        deleteClick();
      }
    };
    watch(() => props.file, () => {
      startUpload();
    }, {
      immediate: true
    });
    watch(() => state.uploadStatus, v => {
      props.file.mediaStatus = v;
    });
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_circle = _resolveComponent("van-circle");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [mediaType.value == 1 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        ref: "imageRef",
        class: "file-img",
        src: __props.file.objectUrl,
        fit: "contain",
        onClick: showBigClick
      }, null, 8, ["src"])) : mediaType.value == 2 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "file-video-main",
        onClick: playVideoClick
      }, [_createElementVNode("video", {
        class: "file-video",
        src: __props.file.objectUrl
      }, null, 8, _hoisted_2), state.uploadStatus == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), state.uploadStatus != 2 ? (_openBlock(), _createElementBlock("span", _hoisted_6, [state.uploadStatus == 0 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => startUpload()),
        style: {
          "color": "#778",
          "font-size": "13px"
        }
      }, "数据整理中...")) : state.uploadStatus == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [mediaType.value == 2 ? (_openBlock(), _createBlock(_component_van_circle, {
        key: 0,
        "current-rate": state.percentage,
        "onUpdate:currentRate": _cache[1] || (_cache[1] = $event => state.percentage = $event),
        rate: rate.value,
        size: "60px",
        text: percentageText.value,
        "stroke-width": 60
      }, null, 8, ["current-rate", "rate", "text"])) : (_openBlock(), _createBlock(_component_van_loading, {
        key: 1,
        type: "spinner"
      }))], 64)) : state.uploadStatus == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_van_button, {
        onClick: _cache[2] || (_cache[2] = $event => startUpload())
      }, {
        default: _withCtx(() => [_createTextVNode("重试")]),
        _: 1
      }), _createVNode(_component_van_button, {
        onClick: deleteClick
      }, {
        default: _withCtx(() => [_createTextVNode("删除")]),
        _: 1
      })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), state.uploadStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_8, [_createElementVNode("div", {
        class: "option-view-delete",
        onClick: deleteClick
      }, [_createVNode(_component_van_icon, {
        name: "clear"
      })])])) : _createCommentVNode("", true), _createVNode(_component_van_overlay, {
        show: state.showVideo
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "play-view",
          onClick: _cache[4] || (_cache[4] = $event => state.showVideo = false)
        }, [_createElementVNode("div", {
          class: "play-view-content",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [state.showVideo ? (_openBlock(), _createElementBlock("video", {
          key: 0,
          src: __props.file.objectUrl,
          controls: ""
        }, null, 8, _hoisted_9)) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["show"])]);
    };
  }
});